<template>
  <CommonList
    selection-type="radio"
    row-key="id"
    :has-more-search="false"
    :auto-load="true"
    ref="listRef"
    cell-overflow="ellipsis"
    @selection-change="handleSelectionChange"
    @current-row-change="handleCurrentRowChange"
    @load-start="handleLoadList"
    @search-click="handleLoadList"
    @pagination-change="handleLoadList"
    @reset-click="handleReset"
  >
    <template #search-item-fixed>
      <div class="common-search-item">
        <label class="common-search-label80">公告内容:</label>
        <el-input v-model="searchForm.content" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">状态:</label>
        <el-select v-model="searchForm.status" class="common-input120" placeholder="请选择" clearable>
          <el-option label="显示" value="1"></el-option>
          <el-option label="隐藏" value="0"></el-option>
        </el-select>
      </div>
    </template>

    <template #btn-group>
      <el-button type="primary" class="list-btn" @click="handleAdd">
        <el-icon><Plus/></el-icon>
        新增
      </el-button>
      <el-button
        type="warning"
        class="list-btn"
        @click="handleEdit"
        :disabled="!listShow"
      >
        <el-icon><Edit/></el-icon>
        修改
      </el-button>
      <el-button
        type="danger"
        class="list-btn"
        @click="handleDelete"
        :disabled="!listShow"
      >
        <el-icon><Delete/></el-icon>
        删除
      </el-button>
    </template>

    <template #table-column>
      <el-table-column prop="content" label="公告内容" align="center" min-width="250"></el-table-column>
      <el-table-column prop="isNew" label="NEW标记" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.isNew === 1 ? 'success' : 'info'">
            {{ scope.row.isNew === 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" width="100">
        <template #default="scope">
          <span>{{ scope.row.sort === -1 ? '置顶' : scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
            {{ scope.row.status === '1' ? '显示' : '隐藏' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="180">
        <template #default="scope">
          {{ $formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </template>

    <template #extra>
      <el-dialog
        v-model="dialogVisible"
        :title="dialogType === 'add' ? '新增公告' : '修改公告'"
        width="600px"
        destroy-on-close
      >
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="100px"
          class="list-modal-form"
        >
          <el-form-item label="公告内容" prop="content">
            <el-input
              v-model="formData.content"
              type="textarea"
              placeholder="请输入公告内容"
              maxlength="255"
              show-word-limit
              :rows="4"
              style="width: 100%;"
            ></el-input>
          </el-form-item>
          <el-form-item label="NEW标记" prop="isNew">
            <el-radio-group v-model="formData.isNew">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number
              v-model="formData.sort"
              :min="-1"
              style="width: 100%;"
              placeholder="-1表示置顶"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio value="1">显示</el-radio>
              <el-radio value="0">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生效方式" prop="effectType" v-if="dialogType === 'edit'">
            <el-radio-group v-model="formData.effectType">
              <el-radio value="1">立即生效</el-radio>
              <el-radio value="2">次日生效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <div style="text-align: center; width: 100%;">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </template>
  </CommonList>
</template>

<script setup>
import useNoticeList from './NoticeList.js';

const {
  searchForm,
  listRef,
  dialogVisible,
  dialogType,
  formRef,
  listShow,
  formData,
  formRules,
  Plus,
  Edit,
  Delete,
  handleSelectionChange,
  handleCurrentRowChange,
  handleAdd,
  handleEdit,
  handleDelete,
  handleLoadList,
  handleReset,
  handleSubmit
} = useNoticeList();
</script>

<style>
@import '../../../assets/css/util/base-list.css';
</style>